import { render, staticRenderFns } from "./area-index.vue?vue&type=template&id=47b2fa72&scoped=true&"
import script from "./area-index.vue?vue&type=script&lang=js&"
export * from "./area-index.vue?vue&type=script&lang=js&"
import style0 from "./area-index.vue?vue&type=style&index=0&id=47b2fa72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2fa72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b2fa72')) {
      api.createRecord('47b2fa72', component.options)
    } else {
      api.reload('47b2fa72', component.options)
    }
    module.hot.accept("./area-index.vue?vue&type=template&id=47b2fa72&scoped=true&", function () {
      api.rerender('47b2fa72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouses/area-index.vue"
export default component.exports